module.exports = __webpack_public_path__ + "img/apple.7e431294.png";